module.exports = __webpack_public_path__ + "static/img/1920.5edde00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/1920.png
// module id = 1bh3
// module chunks = 1